import { atom } from 'recoil';

export const termsState = atom({
  key: 'termsIsAccepted',
  default: false,
});